export default "/images/vendor/flag-icons/flags/4x3/fi.svg?ead68a19c50e3e6f4d042ec0715faf1e";